import React from "react";
import StudentProfile from "./StudentProfile";
import CompanyProfile from "./CompanyProfile";

const Profile = () => {
  const userRole = localStorage.getItem("userRole");
  
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="bg-white border-b border-gray-200 sticky top-0 z-30">
        <div className="px-4 sm:px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-green-100 rounded-lg">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <div>
                <h1 className="text-xl sm:text-2xl font-semibold text-gray-900">
                  Profile
                </h1>
                <p className="text-sm text-gray-600 mt-1">
                  Manage your {userRole === "student" ? "student" : "company"} profile information
                </p>
              </div>
            </div>
            
            {/* Role Badge */}
            <div className="hidden sm:flex items-center">
              <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                userRole === "student" 
                  ? "bg-blue-100 text-blue-700 border border-blue-200" 
                  : "bg-purple-100 text-purple-700 border border-purple-200"
              }`}>
                <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                  {userRole === "student" ? (
                    <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z"/>
                  ) : (
                    <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm3 5a1 1 0 011-1h4a1 1 0 110 2H8a1 1 0 01-1-1zm0 3a1 1 0 011-1h4a1 1 0 110 2H8a1 1 0 01-1-1z" clipRule="evenodd"/>
                  )}
                </svg>
                {userRole === "student" ? "Student" : "Organization"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Content */}
      <div className="flex-1">
        {userRole === "student" ? <StudentProfile /> : <CompanyProfile />}
      </div>
    </div>
  );
};

export default Profile;